import { number, object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT, NUMBER_TYPE_TEXT, MIN_ZERO_VALIDATION_TEXT } =
        getValidationTexts();

    return object().shape({
        city: string().required(REQUIRED_TEXT).nullable(),
        country: string().required(REQUIRED_TEXT).nullable(),
        state: string().required(REQUIRED_TEXT).nullable(),
        wind_speed: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, MIN_ZERO_VALIDATION_TEXT)
            .nullable(),
    });
};
